import { ILegal } from "../../types/Legal";
import authAxios, { authHeader } from "../data";

const edit = async (contactId: string, req: ILegal) => {
  const result = await authAxios.put(`/api/Contracts/${contactId}/legal`, req, {
    headers: authHeader(),
  });

  return result.data;
};

const LegalService = {
  edit,
};

export default LegalService;
